<template>
    <div class="pop_black"
         v-if="imgList.length > 0"
         @click="close">
        <img class="imgBox"
             :src="imgList[index]"></img>
        <ul class="imgList">
            <li v-for="(item, index) in imgList"
                :style="{'background': `url(${item}) center center no-repeat`, 'background-size': 'contain'}"
                @click="showIndex(index)"></li>
        </ul>
    </div>
</template>
<script>
export default {
    data() {
        return {
            index: 0
        };
    },
    props: ["imgList"],
    methods: {
        showIndex(index) {
            this.index = index;
        },
        close() {
            this.index = 0;
            this.$emit("close");
        }
    }
};
</script>
<style lang="scss" scope>
.pop_black {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background: rgba($color: #000000, $alpha: 0.5);
    overflow: hidden;
    text-align: center;

    .imgBox {
        height: 75%;
        // width: 70%;
        margin: 50px auto;
    }
    .imgList {
        height: 80px;
        margin-top: 50px;
        margin: 0 auto;
        display: flex;
        justify-content: center;
        align-items: center;
        li {
            width: 80px;
            height: 80px;
            margin-right: 20px;
            cursor: pointer;
        }
        li:last-child {
            margin-right: 0;
        }
    }
}
</style>